module.exports = __webpack_public_path__ + "static/img/10019 (1).aa47dc0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10019 (1).jpg
// module id = UL6c
// module chunks = 14